<template lang="pug">
  .unboxed
    .a-box-xs-3x4.a-box-sm-4x3.a-box-md-3x1.a-box-lg-12x5.max-at-tweak
      .a-box-content
        img-box(media-id="5476")
    .description.text-center.md-6.p-6-left.p-6-right.flex-box.column.center-major-axis
      SectionTitle.xs-pb-100m.xs-pr-100m.xs-pl-100m the pampered salon experience in a box
      p.xs-f-small.lg-f-medium.max-at-tweak Thoughtfully designed. Tested by celebrity stylists. Our&nbsp;
        a.underline(href="/home-hair-color-kit" target="_self") Color Kit
        |  is all you need to color at home with total confidence.

</template>

<script>
  import SectionTitle from "../../../SectionTitle";

  export default {
    name: "ColorKitUnboxed",

    components: {
      SectionTitle
    }
  }
</script>

<style scoped lang="stylus">
  .description
    position absolute
    top 0
    right 0
    height 100%

  @media mq-mobile
    .description
      justify-content flex-start
      margin-top 2em 
  @media mq-tablet
    .description
      padding-left 18% !important
      padding-right 18% !important
      justify-content flex-start
      margin-top 2em
</style>

